import { format } from 'date-fns';

/**
 * Formatting for the optional per-discount limits shown in the admin.
 *
 * A discount with no dates of its own follows the product gate, so its label is
 * the literal phrase "Same as product gate" — never a blank — and wherever there
 * is room, the gate's actual dates are shown next to it.
 */

export const SAME_AS_GATE = 'Same as product gate';

const fmt = (d: Date | number | string) => format(new Date(d), 'MMM d, h:mm a');

/** "Oct 13, 12:00 PM – Oct 20, 12:00 PM", with open ends spelled out. */
export function formatRange(
  start: Date | number | string | null | undefined,
  end: Date | number | string | null | undefined
): string {
  const from = start ? fmt(start) : 'Gate start';
  const to = end ? fmt(end) : 'Gate end';
  return `${from} – ${to}`;
}

/** Short label for the rules table. */
export function discountDatesLabel(rule: {
  startDate?: string | null;
  endDate?: string | null;
}): string {
  if (!rule.startDate && !rule.endDate) return SAME_AS_GATE;
  return formatRange(rule.startDate, rule.endDate);
}

export function discountCapLabel(maxRedemptions?: number | null): string {
  return maxRedemptions ? `${maxRedemptions}` : 'No limit';
}
